import React, { useState } from "react";
import { ListItem } from "@deere/ux.uxframe-react";
import "../assets/css/SearchPage.css";
import { CRS_SURVEY_CODES, DOWNLOAD_LINK, OS, SCBM_CODE, SCBM_INDIRECT, ST, COO, CRS_SURVEY_TEMPLATES } from "../utils/surveyLiterals"
import { Spinner } from '@deere/ux.uxframe-react'
import { getExcel, getExcelGeneric, getExcelIndirect, getExcelSubtier, getExcelOs, getExcelCoo, getExcelGenericParts } from '../services/download.service';
import { useHistory } from "react-router";
import { getDateFromTimeStamp } from '../utils/utils';
import { Button } from "@deere/fuel-react"

export const CampaignListItem = ({
    accessToken,
    campaign,
    responsesSubmitted
}) => {
    const history = useHistory()
    const [downloadingFile, setDownloading] = useState(false)
    const getDownloadFile = (surveyId, campaignId) => {
        try {
            setDownloading(true)
            getExcel(surveyId, campaignId, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileIndirect = (surveyId, campaignId) => {
        try {
            setDownloading(true)
            getExcelIndirect(surveyId, campaignId, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileSubtier = (campaignId) => {
        try {
            setDownloading(true)
            getExcelSubtier(campaignId, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    }

    const getDownloadFileGeneric = (surveyId, campaignId, surveyCode) => {
        try {
            setDownloading(true)
            getExcelGeneric(surveyId, campaignId, surveyCode, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileOs = (surveyId, campaignId, surveyCode) => {
        try {
            setDownloading(true)
            getExcelOs(surveyId, campaignId, surveyCode, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileCoo = (surveyId, campaignId, surveyCode) => {
        try {
            setDownloading(true)
            getExcelCoo(surveyId, campaignId, surveyCode, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    const getDownloadFileGenericParts = (surveyId, campaignId, surveyCode, isNonDeere) => {
        try {
            setDownloading(true)
            getExcelGenericParts(surveyId, campaignId, surveyCode, isNonDeere, accessToken).then(r =>
                setDownloading(false)
            ).catch(err => setDownloading(false))
        }
        catch (err) {
            throw err
        }
    };

    function openDetailScreen(campaign) {
        history.push({
            pathname: '/details',
            state: { campaign: campaign, previous: history.location.pathname }
        })
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (campaign.templateType === CRS_SURVEY_TEMPLATES.PART) {
            getDownloadFileGenericParts(campaign.surveyId, campaign.id, campaign.surveyCode, campaign.isNonDeere)
        } else {
            switch(campaign.surveyCode){
                case SCBM_CODE:
                    getDownloadFile(campaign.surveyId, campaign.id)
                    break;
                case  SCBM_INDIRECT:
                    getDownloadFileIndirect(campaign.surveyId, campaign.id)
                    break;
                case ST:
                    getDownloadFileSubtier(campaign.id)
                    break;
                case OS:
                    getDownloadFileOs(campaign.surveyId, campaign.id, campaign.surveyCode)
                    break;
                case COO:
                    getDownloadFileCoo(campaign.surveyId, campaign.id, campaign.surveyCode)
                    break;
                default:
                    getDownloadFileGeneric(campaign.surveyId, campaign.id, campaign.surveyCode)
                    break;
            }
        }
    }

    const spinner = () => (
        <div className='ml-2'>
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
        </div>
    )

    const downloadLink = () => (campaign.surveyCode === CRS_SURVEY_CODES.CM || campaign.surveyCode === CRS_SURVEY_CODES.EM || campaign.surveyCode === CRS_SURVEY_CODES.TPSMEX || (campaign.surveyCode === CRS_SURVEY_CODES.TPS && campaign.templateType === "")) ? null : <Button variant="text-inline" onClick={handleSubmit}>{DOWNLOAD_LINK}</Button>;


    return (
        <ListItem className="list-group-item mb-1">
            <div className="d-flex w-100 justify-content-between">
                {campaign.id !== 0 ? <Button variant="text-inline" size="large" onClick={e => openDetailScreen(campaign)}>{`# ${campaign.id} - ${campaign.surveyType}`}</Button> : campaign.surveyType}
                <span>
                    <span className="mr-2 font-weight-bold">Campaign Status</span>
                    <span>{campaign.status}</span>
                </span>
            </div>
            <div className="d-flex w-100 justify-content-between">
                <span>
                    <span className="mr-2 font-weight-bold">Responses Submitted</span>
                    <span>
                        {responsesSubmitted} &nbsp; {downloadingFile ? spinner() : downloadLink()}
                    </span>
                </span>
                <span>
                    <span className="mr-2 font-weight-bold">End Date</span>
                    <span>{getDateFromTimeStamp(campaign.endDate)}</span>
                </span>
            </div>
        </ListItem>
    );
};
